// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__i0PHo","dragIcon":"SortableItem_dragIcon__2KRnQ","disabled":"SortableItem_disabled__-gcqb"};